<ifc-error-base-page 
    [actionType]="actionType$ | async">
</ifc-error-base-page>
